/*
 * @Author: your name
 * @Date: 2021-04-13 20:44:52
 * @LastEditTime: 2023-03-12 22:18:16
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\config\serverPath.js
 */
// 注意修改地址，测试的时候为'' , 加载的时候要换成正常服务器地址，例如：'http://th.taohan.kr'
// http://th.taohan.kr
export const ServerPath = "http://th.taohan.kr";

// 图片服务器地址
export const ImagePath = "http://th.taohan.kr";

// PC页面地址
export const pcPath = "http://taohan.kr";

// 手机页面地址
export const mPath = "http://m.taohan.kr";